// extracted by mini-css-extract-plugin
export default {"wrap":"ReferralView_wrap__FSZxc","check-left-line":"ReferralView_check-left-line__9JJQA","checks":"ReferralView_checks__uEjei","active":"ReferralView_active__bzurs"};